/**
 * tap/spotlightTap 스텝의 "진입 제스처 잔류 pointerup"을 1회 소비하는 상태 게이트.
 *
 * 문제: 탭 진입 튜토리얼은 탭바 셀 `pointerdown`으로 시작되는데(SegmentedTabBar 규약), 그 진입이
 * 띄운 tap 오버레이에 **같은 제스처의 pointerup**이 곧바로 전파되면 스텝이 즉시 advance돼 "찰나에
 * 사라진다". 시계 비교(pointer.downTime vs scene.time.now)는 두 시계의 기준점이 달라(DOM 이벤트
 * 타임스탬프 vs 게임 루프 시각) 불안정하므로, **오버레이 설치 순간 손가락이 눌려 있었는지**라는
 * 상태를 직접 본다: 눌려 있었으면(= 진입 제스처 진행 중) 그 제스처의 **첫 pointerup 1회를 무시**한다.
 * 설치 시점에 떼어져 있었으면(새 탭) 첫 떼기부터 정상 진행.
 */
export interface EnteringGestureGate {
  /** pointerup이 진행(advance)으로 인정되면 true. 진입 제스처의 첫 떼기는 false(1회 소비). */
  shouldAdvance(): boolean;
}

export function createEnteringGestureGate(pointerDownAtInstall: boolean): EnteringGestureGate {
  let ignoreNext = pointerDownAtInstall;
  return {
    shouldAdvance(): boolean {
      if (ignoreNext) {
        ignoreNext = false;
        return false; // 진입 제스처 잔류 떼기 — 무시
      }
      return true;
    },
  };
}
